<template>
  <div :style="standalone ? '' : 'height: ' + headerHeight + 'px; position: relative; z-index: 300000'"
       :class="standalone? 'border-bottom' :''" data-test-path="header-bar">
    <div :class="'toolbars-bg pl-0 pr-0 no-gutters container-fluid' + (searchBarClass ? searchBarClass : '')"
         :style="standalone ? '' : 'position: absolute; z-index: 0'" ref="content">

      <b-row style="padding-left: 1px" class="no-gutters px-0 pb-1 hdr-pb">
        <slot name="primaryButtons">
        </slot>
        <footer-button type="New" class="col-auto pt-1 pl-1 pr-0 grid-btn-h" label-break-point="lg"
                       :data-test-path="form ? 'grid-header-new' + '-' + form.formTitle : 'grid-header-new'"
                       v-if="primaryVisible" :disabled="!primaryEnabled" @new="primaryClick">
        </footer-button>
        <footer-button class="col-auto pt-1 pl-1 pr-1 grid-btn-h" type="Details" label-break-point="lg"
                       :data-test-path="form ? 'grid-header-details' + '-' + form.formTitle : 'grid-header-details'"
                       v-if="buttonsStateWhileCategoryParent && secondaryVisible" :disabled="!secondaryEnabled"
                       @details="secondaryClick">
        </footer-button>
        <b-button v-if="form && form.formClass === 'OrderDetails'" :disabled="!secondaryEnabled"
                  class="bg-primary text-light mt-1" style="height: 38px !important;" @click="openBranding">
          <font-awesome-icon icon="tag"></font-awesome-icon>
          <span class="no-text">{{ $tr('brandingSettings', 'Branding Settings') }}</span>
        </b-button>

        <b-col cols="auto" class="pt-1 pl-1 pr-0 " v-if="showToolButtons">
          <div class="btn-group" role="group" aria-label="Basic example">
            <slot name="toolButton1">
              <b-btn v-if="showSearch"
                     :data-test-path="form ? 'grid-header-query' + '-' + form.formTitle : 'grid-header-query'"
                     :variant="searchVisible || activeColId ? 'plm-toolbar-selected' : 'plm-toolbar-secondary'"
                     @click="searchVisibleClick">
                <font-awesome-icon icon="search"/>
              </b-btn>
            </slot>


            <b-btn
                data-test-path="grid-multiselect"
                v-if="multiSelectEnabled"
                :variant="multiSelectVisible ? 'plm-toolbar-selected' : 'plm-toolbar-secondary'"
                @click="multiSelectVisibleClick">
              <font-awesome-icon icon="list-check"/>
            </b-btn>

            <slot name="toolButton2">
              <b-btn variant="plm-toolbar-secondary" @click="reload" v-if="showReload">
                <font-awesome-icon :icon="['fas', 'sync']"/>
              </b-btn>
            </slot>
            <slot name="toolButton3">
              <b-btn variant="plm-toolbar-secondary" @click="showColumnsDialog" v-if="showColumns">
                <font-awesome-icon :icon="['fad', 'line-columns']"/>
              </b-btn>
            </slot>

            <slot name="toolButtons">
            </slot>

          </div>
        </b-col>
        <b-col cols="auto" class="pt-0 pl-1 pr-0" v-if="showToolButtons">
          <slot name="secondToolButtons">
          </slot>
        </b-col>

        <b-col cols="auto" class="pt-1 pl-0 pr-0">
          <slot name="middleButtons">
          </slot>
        </b-col>

        <b-col cols="" class="pb-1 pl-1" style="overflow: hidden" ref="filler"></b-col>

        <footer-button class="col-auto pt-1 pl-0 pl-sm-1 pr-1 grid-btn-h" type="Delete" label-break-point="lg"
                       :data-test-path="form ? 'grid-header-delete' + '-' + form.formTitle : 'grid-header-delete'"
                       v-if="showDelete" :disabled="!deleteEnabled"
                       @delete="deleteClick"></footer-button>
        <slot name="dangerButton">
        </slot>

        <b-col cols="auto pt-1 pl-0 pr-1" v-if="toolbox">
          <side-menu-toggle ref="sideMenuToggle" :form="form" :toolbox="toolbox">
          </side-menu-toggle>
        </b-col>


      </b-row>
      <b-row class="no-gutters pl-0 pt-0">
        <div :class="'pt-0 pl-0 pr-0 pr-sm-1 pl-sm-1 pb-0 ' + filtersColsClasses" ref="filters">
        </div>
      </b-row>
      <b-row class="no-gutters pl-0 pt-0" v-if="searchOn || searchVisible">
        <div :class="'col-auto pl-0 pr-0 ' + (searchBarClass ? searchBarClass : '')">
          <div class="d-flex pt-1 pb-1" data-test-path="search-query" style="line-height: unset">
            <div style="width: 0px">
                <span :class="statusColor" style="position: relative; left: 15px; top:8px">
                    <font-awesome-icon :icon="['fa', 'search']"/>
                </span>
            </div>
            <b-form-input class="mr-1 ml-1"
                          autocomplete="off"
                          :style="'padding-left: 32px; min-width: 310px; width:100vw; max-width: 710px;' + (searchInput.length < 3 ? 'color: red;':'')"
                          :placeholder="columnData && activeColId ? $tr('searchForPlac', 'Search for') + ' ' + columnData.name : $tr('searchForSlow', 'Search for all (slow engine)')"
                          v-model="searchInput"
                          @keypress="searchChanged"
                          @keydown.stop="onKeyUp"
                          @focusout="searchFocusout"
                          ref="query"
            ></b-form-input>
            <div style="width: 0px; text-overflow: clip;">
                <span style="position: relative; top:7px; margin-left: -24px">
                  <a href="#" @click="clearClicked" ref="clearLink" :class="statusColor"
                     style="position: relative; top:1px">
                      <font-awesome-icon :icon="['fa', 'times']" transform class="pr-2"/>
                  </a>
                </span>
            </div>

          </div>
        </div>
      </b-row>
    </div>
  </div>
</template>
<script>

import DialogsMountPoint from "@/components/dialogs/DialogsMountPoint";
import ActivityManager from "@/activity/ActivityManager";
import FooterButton from "@/components/navbar/FooterButton";
import SideMenuButton from "@/components/navbar/SideMenuToggle";
import SideMenuToggle from "@/components/navbar/SideMenuToggle";
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import {nextAnimationFrame} from "@/utils/Executors";
import ProductInSeason from "@/server/com/silkplm/model/plm/ProductInSeason";
import FormsLoader from "@/components/forms/FormsLoader";
import ProductWCLElements from "@/server/com/silkplm/model/plm/ProductWCLElements";
import IntFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/IntFormFieldConfig";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";

export default {
  components: {SideMenuToggle, SideMenuButton, FooterButton},
  async created() {
  },

  mounted() {
    if (this.toolbox) {
      this.$refs.sideMenuToggle.connectFillerBox(this.$refs.filler);
    }
  },

  methods: {
    setFocusForLoop() {
      clearTimeout(this.pendingTimer);
      this.pendingTimer = null;
      this.$nextTick(() => {
        if(this.searchInput?.length) {
          this.clearData();
          this.executeQuery();
        }
        this.$refs.query.focus();
      });
    },

    installInGrid(dataGrid) {
      this.dataGrid = dataGrid;
      this.waitForResize = false;
      this.resizeObserver = new ResizeObserver(entries => {
        if (this.waitForResize) {
          return;
        }
        this.waitForResize = true;
        nextAnimationFrame(() => {
          this.waitForResize = false;
          for (let entry of entries) {
            let realH = 0;
            if (entry.contentBoxSize) {
              // Firefox implements `contentBoxSize` as a single content rect, rather than an array
              const contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;
              realH = contentBoxSize.blockSize;
            } else {
              realH = entry.contentRect.height;
            }
            this.headerHeight = (realH);
            if (this.dataGrid.holder) {
              this.dataGrid.holder.style['height'] = 'calc(100% - ' + (realH) + 'px )';
            }
            if (this.dataGrid.v3) {
              if (this.dataGrid.$refs.v3Holder) {
                this.dataGrid.$refs.v3Holder.style['height'] = 'calc(100% - ' + (realH) + 'px )';
              }
            }
          }
        });
      });

      let content = this.$refs['content'];
      this.resizeObserver.observe(content);
      ActivityManager.findActivity(this.$el)?.addUnmountTrigger(() => {
        this.resizeObserver.unobserve(content);
        this.resizeObserver.disconnect();
      });
    },

    primaryClick() {
      this.$emit("primary-click");
    },
    deleteClick() {
      this.$emit("delete-click");
    },
    secondaryClick() {
      this.$emit("secondary-click");
    },

    openBranding() {
      this.$emit("open-branding");
    },

    searchFocusout() {

    },

    reload() {
      this.dataGrid._reload();
    },
    onKeyUp(ev) {
      let key = ev.keyCode || ev.charCode;

      if (key == 8 || key == 46) {
        this.searchChanged("Backspace");
      }
      if (key == 27) {
        this.searchChanged("Escape");
      }
      if (key == 13) {
        this.searchChanged("Enter");
      }
      if (key == 46) {
        this.searchChanged("Del");
      }
    },

    searchChanged(key) {
      if (key == "Enter" || key?.key == "Enter") {
        // this.lastQuery = null;
        this.searchClicked();
        return false;
      }
      if (key == "Escape" || key?.key == "Escape") {
        this.clearClicked();
        return false;
      }

      if (this.pendingTimer) {
        clearTimeout(this.pendingTimer);
        this.pendingTimer = null;
      }

      this.pendingTimer = setTimeout(() => {
        this.executeQuery();
        clearTimeout(this.pendingTimer);
        this.pendingTimer = null;
      }, 1000);
    },

    injectFilters(el) {
      this.$refs["filters"].appendChild(el);
    },

    searchClicked() {
      clearTimeout(this.pendingTimer);
      this.pendingTimer = null;
      this.executeQuery();
      this.$refs["query"].focus();
    },
    searchVisibleClick() {
      if (!this.searchVisible) {
        if (this.activeColId) {
          this.$emit("noActiveCol");
        }
        this.searchVisible = true;
        setTimeout(() => {
          this.$refs["query"].focus();
        });
      } else {
        if (!this.activeColId) {
          this.searchVisible = false;
          this.clearClicked();
        } else {
          this.$emit("noActiveCol");
          this.clearClicked();
          setTimeout(() => {
            this.$refs["query"].focus();
          });
        }
      }
    },
    clearData() {
      this.searchInput = "";
    },
    clearClicked() {
      clearTimeout(this.pendingTimer);
      this.pendingTimer = null;
      let skipQ = false;
      if (this.lastQuery === "" && this.searchInput === "") {
        skipQ = true;
      }
      this.$emit("clearClicked");

      this.searchInput = "";
      if (!skipQ) {
        this.executeQuery();
      }
      this.$refs["query"].focus();
    },

    clearQuery() {
      clearTimeout(this.pendingTimer);
      this.pendingTimer = null;
      let tmp = this.searchInput;
      this.lastQuery = null;
      this.searchInput = "";
      this.searchVisible = false;
      this.$emit("clearClicked");
      if (tmp !== "") {
        this.executeQuery()
      }
    },

    executeQuery() {
      if (!this.searchInput) {
        this.statusColor = "text-secondary";
      } else {
        this.statusColor = "text-success";
      }
      if(this.searchInput === this.lastQuery) {
        return
      }
      let query = this.searchInput ?? "";
      if (query.length < 3) {
        if (!this.activeColId) {
          query = "";
        } else {
          let field = null;
          let fields = this.form.fields.filter(field => field.fieldName === this.activeColId);
          if (fields && fields.length) {
            field = fields[0];
          }
          if (field) {
            if (field instanceof TextFormFieldConfig) {
              query = "";
            }
          } else {
            query = "";
          }
        }
      }
      if (this.lastQuery === query) {
        return;
      }
      this.dataGrid?.search(query);
      if (!this.dataGrid) {
        this.$emit("search", query);
      }
      this.lastQuery = this.searchInput;
    },

    showColumnsDialog() {
      return new Promise((resolve, reject) => {
        DialogsMountPoint.instance.$bvModal.show("bv-modal-columns");
        let dialog = DialogsMountPoint.instance.$refs['columnsDialog'];
        dialog.reset();
        dialog.setDataGrid(this.dataGrid);
        dialog.resolve = resolve;
      });
    },

    multiSelectVisibleClick() {
      this.multiSelectVisible = !this.multiSelectVisible;
      this.$emit("showMultiSelect", this.multiSelectVisible);

      //This event is emitted to prevent default column sorting on RevoGrid
      // EventBus.$emit(Events.keepDefaultSorting);
    },

    turnOnMultiSelect() {
      this.multiSelectVisible = true;
      this.$emit("showMultiSelect", this.multiSelectVisible);
    }
  },
  props: {
    showReload: {type: Boolean, default: false},
    showSearch: {type: Boolean, default: true},
    searchBarClass: {type: String, default: ""},

    primaryEnabled: {type: Boolean, default: true},
    primaryVisible: {type: Boolean, default: true},

    secondaryEnabled: {type: Boolean, default: false},
    secondaryVisible: {type: Boolean, default: true},


    deleteEnabled: {type: Boolean, default: false},
    searchOn: {type: Boolean, default: false},
    columnData: {default: null},
    activeColId: {default: null},

    showDelete: {type: Boolean, default: true},
    buttonsStateWhileCategoryParent: {type: Boolean, default: true},

    showToolButtons: {type: Boolean, default: true},
    showRightMenu: {type: Boolean, default: false},
    toolbox: {default: null},
    standalone: {default: false},
    showColumns: {default: true},
    selectionSize: {default: 0},

    multiSelectEnabled: {default: false},
    form: {type: BaseFormConfig},
    editMultiSelectFromTab: {default: false}
  },

  watch: {
    // toolbox: async function (val) {
    //   console.log(val);
    // },
    editMultiSelectFromTab: function (val) {
      this.multiSelectVisible = val;
      this.$emit("update:showMultiSelect", this.multiSelectVisible);
    },
  },
  data: () => ({
    filtersColsClasses: {type: String, default: "col-auto"},
    dataGrid: null,
    headerHeight: 0,
    searchInput: "",
    lastQuery: "",
    statusColor: "text-secondary",
    searchVisible: false,
    multiSelectVisible: false
  })

};
</script>
<style scoped>
@media screen and (max-width: 990px) {
  .no-text {
    display: none;
  }
}
</style>